const emailRegex = new RegExp('^(?=.{1,50}$)[a-zA-Z0-9_!#$%&*+/=?`{|}~^.-]+@[a-zA-Z0-9_-]+\\.[a-zA-Z0-9.]+$');
export const VerifyEmail = (email: string) => {
  return emailRegex.test(email);
};
